import { render, staticRenderFns } from "./UserItem.vue?vue&type=template&id=cf3e81ae&scoped=true"
import script from "./UserItem.vue?vue&type=script&lang=ts"
export * from "./UserItem.vue?vue&type=script&lang=ts"
import style0 from "./UserItem.vue?vue&type=style&index=0&id=cf3e81ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3e81ae",
  null
  
)

export default component.exports